export const customerFormData = {
	fullName: [
		{
			name: 'first-name',
			model: 'first_name',
			placeholder: 'Förnamn',
			type: 'text',
			icon: 'user',
			required: true,
		},
		{
			name: 'last-name',
			model: 'last_name',
			placeholder: 'Efternamn',
			type: 'text',
			icon: 'user',
			required: true,
		},
	],
	ssn: [
		{
			name: 'ssn',
			model: 'ssn',
			placeholder: 'Personnummer (ÅÅMMDDXXXX)',
			type: 'number',
			inputmode: 'numeric',
			pattern: '[0-9]*',
			icon: 'user',
			required: true,
		},
	],
	address: [
		{
			name: 'street',
			model: 'street_address',
			placeholder: 'Gatuadress',
			type: 'text',
			icon: 'house',
			required: true,
			zipAndCity: [
				{
					name: 'zip',
					model: 'zip_code',
					placeholder: 'Postnummer',
					type: 'number',
					inputmode: 'numeric',
					pattern: '[0-9]*',
					icon: 'geopin',
					style: 'width: 40%',
					required: true,
				},
				{
					name: 'city',
					model: 'city',
					placeholder: 'Postort',
					type: 'text',
					icon: 'geopin',
					style: 'width: 60%',
					required: true,
				},
			],
		},
	],
	contactInfo: [
		{
			name: 'phone',
			model: 'phone',
			placeholder: 'Telefonnummer',
			type: 'tel',
			inputmode: 'tel',
			icon: 'phone',
			required: true,
		},
		{
			name: 'email',
			model: 'email',
			placeholder: 'E-postadress',
			type: 'email',
			inputmode: 'email',
			icon: 'mail',
			required: true,
		},
	],
	emailConfirmation: [
		{
			name: 'confirm-email',
			model: 'internalConfirmedEmail',
			placeholder: 'Bekräfta e-postadress',
			type: 'email',
			inputmode: 'email',
			icon: 'mail',
			emailComparison: 'email',
			required: true,
		},
	],
	/* Info used specifically for corporate customers */
	corporateName: [
		{
			name: 'corporate-name',
			model: 'corporate_name',
			placeholder: 'Företagsnamn',
			type: 'text',
			icon: 'corporate',
			required: true,
		},
	],
	invoiceDetails: [
		{
			name: 'invoice-email',
			model: 'invoice_email',
			placeholder: 'E-postadress för faktura',
			type: 'email',
			inputmode: 'email',
			icon: 'mail',
			required: true,
		},
		{
			name: 'invoice-reference',
			model: 'invoice_reference',
			placeholder: 'Referens på fakturan',
			type: 'text',
			glyphicon: 'tag',
			maxlength: '50',
			required: true,
		},
	],
	deliveryDetails: [
		{
			name: 'delivery_id',
			model: 'deldelivery_idivery_street_address',
			type: 'hidden',
		},
		{
			name: 'delivery_phone',
			model: 'delivery_phone',
			placeholder: 'Telefonnummer för avisering',
			type: 'tel',
			inputmode: 'tel',
			icon: 'phone',
			required: true,
		},
		{
			name: 'delivery_email',
			model: 'delivery_email',
			placeholder: 'E-postadress för avisering',
			type: 'email',
			inputmode: 'email',
			icon: 'mail',
			required: true,
		},
		{
			name: 'delivery_attention',
			model: 'delivery_attention',
			placeholder: 'Att/Godsmärkning',
			type: 'text',
			glyphicon: 'tag',
			maxlength: '50',
			required: true,
		},
	],
	deliveryAddress: [
		{
			name: 'delivery_name',
			model: 'delivery_corporate_name',
			placeholder: 'Företagsnamn',
			type: 'text',
			icon: 'corporate',
			required: true,
		},
		{
			name: 'delivery_street',
			model: 'delivery_street_address',
			placeholder: 'Gatuadress',
			type: 'text',
			icon: 'house',
			required: true,
			zipAndCity: [
				{
					name: 'delivery_zip',
					model: 'delivery_zip_code',
					placeholder: 'Postnummer',
					type: 'number',
					inputmode: 'numeric',
					pattern: '[0-9]*',
					icon: 'geopin',
					style: 'width: 40%',
					required: true,
				},
				{
					name: 'delivery_city',
					model: 'delivery_city',
					placeholder: 'Postort',
					type: 'text',
					icon: 'geopin',
					style: 'width: 60%',
					required: true,
				},
			],
		},
	],
};
